module.exports = __webpack_public_path__ + "fonts/capture-it2.e2fdba39.ttf";